import { useEffect, useState } from 'react';
import Pagination from '../../components/pagination/Pagination';
import './orgReviews.css';
import ReviewStars from '../../components/reviewStars/ReviewStars';
import { fetchOrgReviews, getTrips, reviewsCount } from './orgReviewsFun/orgReviewsFun';
import ReactLoading from 'react-loading';
import EmptyPage from '../../components/empty-page/emptyPage';
import { standardDate } from '../../utils/formatDate';

const OrgReviews = () => {
    const [reviews, setReviews] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [offSet, setOffSet] = useState(0);
    const [trips, setTrips] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState('');
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [datesType, setDatesType] = useState('fixed');
    const [group, setGroup] = useState('backpacking');
    const limit = 10;
    const totalData = totalCount;
    const tableHeader = ['Trip Name', 'User Name', 'Rating', 'Comments'];

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    // Fetch TRIPS only when filters change
    useEffect(() => {
        getTrips(datesType, group, setTrips, setLoading);
        setSelectedTrip('');
    }, [datesType, group]);

    // Fetch REVIEWS when trip or pagination changes
    useEffect(() => {
        fetchOrgReviews(setReviews, setLoading, offSet, selectedTrip);
    }, [selectedTrip, offSet]);

    useEffect(() => {
        reviewsCount(setTotalCount, selectedTrip, setLoading);
    }, [selectedTrip]);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            setPageNumber(+number);
            setOffSet(+offSetNumber);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    const getReviewStars = (rating) => {
        return (
            <div className='org_tripCardNumInfo'>
                <ReviewStars rating={rating} />
                <span>{rating ?? 'N/A'}</span>
            </div>
        );
    };

    const getTripDetails = (row) => {
        return (
            <div className='bookingTitleArea'>
                <div>{row?.packId.title ?? 'N/A'}</div>
                <div>
                    {standardDate(row.createdAt.split('T')[0])} (
                    {`${row?.packId?.days ?? '(N/A)'}D/${row?.packId?.nights ?? '(N/A)'}N`})
                </div>
            </div>
        );
    };
    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='orgReviews'>
                <h2 className='orgReviewsHeading'>Reviews</h2>
                <div className='orgReviewFilter'>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        onChange={(e) => {
                            setSelectedTrip('');
                            setDatesType(e.target.value);
                            setPageNumber(1);
                            setOffSet(0);
                        }}
                    >
                        <option value='fixed'>Fixed</option>
                        <option value='custom'>Custom</option>
                    </select>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        onChange={(e) => {
                            setSelectedTrip('');
                            setGroup(e.target.value);
                            setPageNumber(1);
                            setOffSet(0);
                        }}
                    >
                        <option value='backpacking'>Backpacking</option>
                        <option value='vehicle'>Vehicle</option>
                    </select>
                    <select
                        name='date'
                        id='date'
                        className='select mr-2'
                        onChange={(e) => setSelectedTrip(e.target.value)}
                    >
                        <option value=''>Select Trip</option>
                        {trips.map((trip) => (
                            <option value={trip._id} key={trip._id}>
                                {trip.title}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className='orgReviewsContainer'>
                {reviews?.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='tableContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {tableHeader.map((head, headIndex) => {
                                        return <th key={headIndex}>{head}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {reviews?.map((row, rowIndex) => {
                                    return (
                                        <tr key={rowIndex} className='tableBodyRow'>
                                            <td>{getTripDetails(row)}</td>
                                            <td>{row?.userName ?? 'N/A'}</td>
                                            <td>{getReviewStars(row.rating)}</td>
                                            <td className='reviewComments ellipsisCell'>{row?.comment ?? 'N/A'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className='responsiveCardContainer'>
                            {reviews?.map((row, rowIndex) => (
                                <div key={rowIndex} className='responsiveCard'>
                                    <div className='cardContent'>
                                        <p>
                                            <strong>{tableHeader[0]}:</strong> {getTripDetails(row)}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[1]}:</strong> {row?.userName ?? 'N/A'}
                                        </p>
                                        <p className='ratingCon'>
                                            <strong>{tableHeader[2]}:</strong> {getReviewStars(row.rating)}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[3]}:</strong> {row?.comment ?? 'N/A'}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {/* {reviews.length > 10 && ( */}
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                />
                {/* )} */}
            </div>
        </>
    );
};

export default OrgReviews;
